import { tooltipClasses } from '@mui/material';
import { styled } from '@mui/material/styles';

import { Tooltip } from './components/Tooltip';

import type { TooltipProps } from 'shared/components/Tooltip/types';

const { tooltip: tooltipClassName } = tooltipClasses;

export const Wrapper = styled(Tooltip, {
  shouldForwardProp: prop => prop !== 'maxWidth',
})<Pick<TooltipProps, 'maxWidth'>>(({ maxWidth = 194 }) => ({
  [`& .${tooltipClassName}`]: {
    maxWidth,
  },
}));
